import { Modal } from '@/components/ui/Modal';
import { POS_SHORTCUT_HELP } from '@/constants/posShortcuts';

interface Props {
  open: boolean;
  onClose: () => void;
}

export function ShortcutHelpModal({ open, onClose }: Props) {
  const categories = [...new Set(POS_SHORTCUT_HELP.map((s) => s.category))];

  return (
    <Modal open={open} onClose={onClose} title="POS keyboard shortcuts" size="lg">
      <p className="mb-4 text-sm text-slate-500 dark:text-slate-400">
        Cashier workflow — no mouse required. Press <kbd className="rounded bg-slate-100 px-1 dark:bg-slate-800">Esc</kbd> to close.
      </p>
      <div className="grid gap-6 sm:grid-cols-2">
        {categories.map((cat) => (
          <div key={cat}>
            <h3 className="mb-2 text-sm font-semibold text-primary-600 dark:text-primary-400">{cat}</h3>
            <ul className="space-y-1.5 text-sm">
              {POS_SHORTCUT_HELP.filter((s) => s.category === cat).map((s) => (
                <li key={`${cat}-${s.key}`} className="flex justify-between gap-2 border-b border-slate-100 py-1 dark:border-slate-800">
                  <kbd className="shrink-0 rounded bg-slate-100 px-2 font-mono text-xs dark:bg-slate-800">{s.key}</kbd>
                  <span className="text-right text-slate-600 dark:text-slate-300">{s.action}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </Modal>
  );
}
